<app-media-upload [uploadEnable]="uploadEnable"  [trackName]="trackName" [isShowGallery]="isShowGallery"></app-media-upload>